import { render } from "./ScoreBar.vue?vue&type=template&id=2fa50bdc&scoped=true&ts=true"
import script from "./ScoreBar.vue?vue&type=script&lang=ts"
export * from "./ScoreBar.vue?vue&type=script&lang=ts"

import "./ScoreBar.vue?vue&type=style&index=0&id=2fa50bdc&lang=scss&scoped=true"

import exportComponent from "C:\\Projekty\\VideoPLayer\\player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa50bdc"]])

export default __exports__